import { render, staticRenderFns } from "./Customers.vue?vue&type=template&id=591bd684&scoped=true"
import script from "./Customers.vue?vue&type=script&lang=js"
export * from "./Customers.vue?vue&type=script&lang=js"
import style0 from "./Customers.vue?vue&type=style&index=0&id=591bd684&prod&scoped=true&lang=css"
import style1 from "./Customers.vue?vue&type=style&index=1&id=591bd684&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591bd684",
  null
  
)

export default component.exports